/**
 * What leaves the browser: the certificate, the DXF, and the GeoPackage.
 *
 * All three are the server's, posted back byte for byte so the attestation
 * still verifies. Nothing geographic is built here: browsers cannot write
 * SQLite without shipping a WASM build of it, so the GeoPackage comes from
 * `/v1/geopackage` with the same layer schema the QGIS plugin uses, and a
 * file saved here opens beside one the plugin wrote.
 */

import type { LngLat, Ring } from "./place";
import type { HeldResponse } from "./types";

export interface PlacedTract {
  ring: Ring;
  /** Absent for a georeferenced tract, which the fabric already located. */
  origin?: LngLat;
  rotationDeg: number;
  /** Set instead of `origin` when the server supplied lon/lat rings. */
  georefRings?: [number, number][][];
}

export function download(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

export function baseName(held: HeldResponse): string {
  const name = held.parsed.document ?? "extraction";
  return name.replace(/\.[^.]+$/, "") || "extraction";
}
